import { createContext } from "react"
import { TooltipContext as TooltipContextType } from "./types"
import { initial_tooltip } from "./reducer"

const TooltipContext = createContext<TooltipContextType>({ tooltip: initial_tooltip, dispatch: () => null })
export default TooltipContext
